// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Table, Button, Row, FormGroup, FormControl, Checkbox } from 'react-bootstrap'
import { AlertMessage } from '../components/alertMessage'
import { Loading } from '../components/loading'
import config from '../config/config.json'

export class AssignTrainingIndividuals extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedWorkers: this.props.selectedWorkersFinal,
            alertDisplay: 'none',
            categoryFilter: 'All',
            searchString: '',
            availableCategories: [],
            selectAllWorkers: false
        }

        this.getAvailableCategories(this.props.env, config)

        this.handleOnClickSelectModules = this.handleOnClickSelectModules.bind(this)
        this.selectWorkers = this.selectWorkers.bind(this)
        this.deselectWorkers = this.deselectWorkers.bind(this)
        this.handleSelectWorkersClick = this.handleSelectWorkersClick.bind(this)
        this.searchWorker = this.searchWorker.bind(this)
        this.filterCategory = this.filterCategory.bind(this)
        this.loadCategoryFilterOptions = this.loadCategoryFilterOptions.bind(this)
        this.handleSelectAllWorkers = this.handleSelectAllWorkers.bind(this)
    }

    getAvailableCategories(env, config) {
        fetch(config[env] + config.api.list_categories.endpoint, {
            method: config.api.list_categories.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }

        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    availableCategories: responseJson
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }


    handleOnClickSelectModules(e) {
        e.preventDefault()

        if (this.state.selectedWorkers.length === 0) {
            this.setState({
                alertDisplay: 'block'
            })
        }
        else {
            this.props.handleSelectedWorkersFinal(this.state.selectedWorkers)
            this.props.router.push('/assignTraining/modules')
        }
    }

    handleSelectWorkersClick(e) {
        //console.log((e.target.checked ? "Selected worker: " : "Deselected worker: "), e.target)

        this.setState({
            alertDisplay: 'none'
        })

        if (e.target.checked) {
            this.selectWorkers(e.target.getAttribute("data-workerId"), e.target.getAttribute("data-workerName"))
            e.target.checked = true
        }
        else {
            this.deselectWorkers(e.target.getAttribute("data-workerId"))
            e.target.checked = false
        }
    }

    selectWorkers(id, name) {
        let selectedWorkers = this.state.selectedWorkers
        selectedWorkers.push({
            id,
            name
        })
        this.setState({
            selectAllWorkers: false,
            selectedWorkers
        })
    }

    deselectWorkers(id) {
        let selectedWorkers = this.state.selectedWorkers.filter(worker => {
            return worker.id !== id
        })
        this.setState({
            selectAllWorkers: false,
            selectedWorkers
        })
    }

    handleSelectAllWorkers(e) {
        //console.log(e.target.checked ? "Selected all workers" : "Deselected all workers")
        let workersList = this.props.workers.filter(worker => {

            if (this.state.categoryFilter === "All")
                return true
            else {
                return (worker.categories.indexOf(this.state.categoryFilter) > -1)
            }
        })

        workersList = workersList.filter(worker => {
            return ((worker.first_name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1 || (worker.last_name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1)
        })

        if (e.target.checked) {
            this.setState({
                selectAllWorkers: e.target.checked,
                selectedWorkers: workersList
            })
        }
        else {
            this.setState({
                selectAllWorkers: e.target.checked,
                selectedWorkers: []
            })
        }
    }

    prepareCategoriesDisplay(categories = []) {
        //console.log(categories)

        return categories.map((category, index) => {
            if (index !== categories.length - 1) {
                return (
                    <div key={index}>
                        <span>{category}</span>,
                    </div>
                )
            } else {
                return (
                    <div key={index}>
                        <span>{category}</span>
                    </div>

                )
            }
        })
    }

    filterCategory(e) {
        this.setState({
            categoryFilter: e.target.value
        })
    }

    loadCategoryFilterOptions() {
        return this.state.availableCategories.map((category, index) => {
            return (
                <option key={index} value={category.name}>{category.name}</option>
            )
        })
    }

    searchWorker(e) {
        this.setState({
            searchString: e.target.value
        })
    }

    get records() {
        let workersList = this.props.workers.filter(worker => {
            if (this.state.categoryFilter === "All")
                return true
            else {
                return (worker.categories.indexOf(this.state.categoryFilter) > -1)
            }
        })

        workersList = workersList.filter(worker => {
            return ((worker.first_name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1 || (worker.last_name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1)
        })

        workersList.sort((a, b) => (a.first_name.toLowerCase() + " " + a.last_name.toLowerCase()) < (b.first_name.toLowerCase() + " " + b.last_name.toLowerCase()) ? -1 : 1)

        return workersList.map((worker, index) => {
            //console.log("worker", worker)
            //let lastActiveDate = new Date(worker.last_active_at)
            let wasSelected = false
            let selectAll = this.state.selectAllWorkers

            this.state.selectedWorkers.forEach(selectedWorker => {
                if (worker.id === Number(selectedWorker.id)) {
                    wasSelected = true
                }
            })

            return (
                <tr key={index}>
                    <td>
                        <FormGroup>
                            <Checkbox inline id={worker.id} data-workerId={worker.id} checked={selectAll || wasSelected} onChange={this.handleSelectWorkersClick} data-workerName={worker.first_name + " " + worker.last_name}></Checkbox>
                        </FormGroup>
                    </td>
                    <td>
                        <label>
                            {worker.first_name + ' ' + worker.last_name}
                        </label>
                    </td>
                    <td>
                        {this.prepareCategoriesDisplay(worker.categories)}
                    </td>
                </tr>
            )
        })
    }

    loadWorkers() {
        if (this.props.loading) {
            return (
                <Loading />
            )
        }

        return (
            <section className="worker-listing">
                <Row style={{ display: 'none' }}>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <h4>Selected Individual(s)</h4>
                        <div className="selected-workers"></div>
                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                        <Table responsive bsClass="table">
                            <thead>
                                <tr>
                                    <th>Select Workers</th>
                                    <th>Name</th>
                                    <th>Category</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td>
                                        <form id="selectAll">
                                            <FormGroup>
                                                <Checkbox inline checked={this.state.selectAllWorkers} onChange={this.handleSelectAllWorkers}>Select All</Checkbox>
                                            </FormGroup>
                                        </form>
                                    </td>
                                    <td>
                                        <form id="search">
                                            <FormGroup controlId="formSearchString">
                                                <FormControl type="text" placeholder="Search Name" onChange={this.searchWorker} />
                                            </FormGroup>
                                        </form>
                                    </td>

                                    <td>
                                        <form id="filterCategory">
                                            <FormGroup controlId="formCategoryFilter">
                                                <FormControl componentClass="select" placeholder="select" onChange={this.filterCategory}>
                                                    <option value="All">All</option>
                                                    {this.loadCategoryFilterOptions()}

                                                </FormControl>
                                            </FormGroup>
                                        </form>
                                    </td>
                                </tr>
                                {this.records}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={10} smOffset={7} sm={4} mdOffset={7} md={4}>
                        <Button bsStyle='primary' disabled={this.state.selectedWorkers.length === 0} onClick={this.handleOnClickSelectModules}>Step 2: Select Modules</Button>
                    </Col>
                </Row>
            </section>
        )
    }

    prepareBreadCrumb() {
        return (<div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>)
    }

    render() {
        return (
            <section className="assign-individuals" >
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {this.prepareBreadCrumb()}
                            <h2 className="title">Assign Training</h2>
                        </div>
                    </Col>
                </Row>
                <Row style={{ display: this.state.alertDisplay }}>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <AlertMessage
                            status="danger"
                            message={"You have not selected any individual."}
                        >
                        </AlertMessage>
                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <h3>
                            Step 1: Select Workers
                        </h3>
                    </Col>
                </Row>
                {this.loadWorkers()}
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/assignTrainingIndividuals.js